import { MouseEvent } from 'react';
import { Button } from 'components/ui/Button';
import { EyeIcon } from 'components/icons/Icons';

interface ViewDetailsButtonProps {
  onClick?: () => void;
}

/**
 * Affordance "consulter en lecture seule" affichée à droite d'une card verrouillée.
 * Réutilise le même pattern que les boutons "voir" des listes (SimulationView / ContractView).
 * En mode verrouillé, c'est ce bouton — pas la card — qui ouvre le panel résumé.
 */
export const ViewDetailsButton = ({ onClick }: ViewDetailsButtonProps) => {
  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    onClick?.();
  };
  return (
    <Button color="slate" round onClick={handleClick}>
      <EyeIcon />
    </Button>
  );
};
